/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Post_Not_FoundInputs */

const en_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post not found`)
};

const es_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicación no encontrada`)
};

const de_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beitrag nicht gefunden`)
};

const zh_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`找不到帖子`)
};

const ar_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المقال غير موجود`)
};

const fr_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message introuvable`)
};

const vi_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy bài viết`)
};

const sw_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chapisho halijapatikana`)
};

const th_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบโพสต์`)
};

const bs_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objava nije pronađena`)
};

const ja_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`投稿が見つかりません`)
};

const ko_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`찾을 수 없음`)
};

const pt_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post não encontrado`)
};

const it_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post non trovato`)
};

const sv_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post inte hittat`)
};

const nl_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post niet gevonden`)
};

const da_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post ikke fundet`)
};

const nb_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post ikke funnet`)
};

const fi_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postia ei löytynyt`)
};

const pl_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poczta nie znaleziono`)
};

const ru_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пост не найден`)
};

const tr_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post bulunamadı`)
};

const hi_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पोस्ट नहीं मिला`)
};

const id_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post tak ditemukan`)
};

const ms_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantaran tidak dijumpai`)
};

const cs_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pošta nenalezena`)
};

const el_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η θέση δε βρέθηκε`)
};

const he_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הפוסט לא נמצא`)
};

const af_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plasing nie gevind nie`)
};

const hu_blog_post_not_found = /** @type {(inputs: Blog_Post_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem található bejegyzés`)
};

/**
* | output |
* | --- |
* | "Post not found" |
*
* @param {Blog_Post_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const blog_post_not_found = /** @type {((inputs?: Blog_Post_Not_FoundInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Post_Not_FoundInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_blog_post_not_found(inputs)
	if (locale === "de") return de_blog_post_not_found(inputs)
	if (locale === "zh") return zh_blog_post_not_found(inputs)
	if (locale === "ar") return ar_blog_post_not_found(inputs)
	if (locale === "fr") return fr_blog_post_not_found(inputs)
	if (locale === "vi") return vi_blog_post_not_found(inputs)
	if (locale === "sw") return sw_blog_post_not_found(inputs)
	if (locale === "th") return th_blog_post_not_found(inputs)
	if (locale === "bs") return bs_blog_post_not_found(inputs)
	if (locale === "ja") return ja_blog_post_not_found(inputs)
	if (locale === "ko") return ko_blog_post_not_found(inputs)
	if (locale === "pt") return pt_blog_post_not_found(inputs)
	if (locale === "it") return it_blog_post_not_found(inputs)
	if (locale === "sv") return sv_blog_post_not_found(inputs)
	if (locale === "nl") return nl_blog_post_not_found(inputs)
	if (locale === "da") return da_blog_post_not_found(inputs)
	if (locale === "nb") return nb_blog_post_not_found(inputs)
	if (locale === "fi") return fi_blog_post_not_found(inputs)
	if (locale === "pl") return pl_blog_post_not_found(inputs)
	if (locale === "ru") return ru_blog_post_not_found(inputs)
	if (locale === "tr") return tr_blog_post_not_found(inputs)
	if (locale === "hi") return hi_blog_post_not_found(inputs)
	if (locale === "id") return id_blog_post_not_found(inputs)
	if (locale === "ms") return ms_blog_post_not_found(inputs)
	if (locale === "cs") return cs_blog_post_not_found(inputs)
	if (locale === "el") return el_blog_post_not_found(inputs)
	if (locale === "he") return he_blog_post_not_found(inputs)
	if (locale === "af") return af_blog_post_not_found(inputs)
	if (locale === "hu") return hu_blog_post_not_found(inputs)
	return en_blog_post_not_found(inputs)
});